import { useEffect, useRef } from 'react';
import { useSyncStore } from '../../domains/sync/syncStore';
import { C } from '../tokens';

/** Auto-dismissing compact banner shown at the top of the screen after a confirmed backend sync. */
export function SyncToast() {
  const toast = useSyncStore((s) => s.toast);
  const clearToast = useSyncStore((s) => s.clearToast);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (!toast) return;
    if (timerRef.current !== null) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      clearToast();
      timerRef.current = null;
    }, 2200);
    return () => {
      if (timerRef.current !== null) window.clearTimeout(timerRef.current);
    };
  }, [toast, clearToast]);

  if (!toast) return null;

  return (
    <div
      key={toast.id}
      style={{
        position: 'fixed',
        top: 12,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: 'rgba(12,16,24,0.92)',
        color: C.gr,
        borderRadius: 8,
        padding: '7px 16px',
        fontSize: 12,
        fontWeight: 600,
        boxShadow: '0 2px 12px rgba(0,0,0,0.35)',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        animation: 'toastSlideDown 0.2s ease',
        border: `1px solid ${C.gr}44`,
        backdropFilter: 'blur(6px)',
        maxWidth: '90vw',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      <span style={{ marginRight: 6 }}>✓</span>
      {toast.message}
    </div>
  );
}
